import React from "react";
import styled from "@emotion/styled";

const FormTitleBox = styled.p(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  marginBottom: "4.8rem",
  fontSize: "2rem",
}));

const FormTitle = ({ children }: { children: React.ReactNode }) => {
  return <FormTitleBox>{children as string}</FormTitleBox>;
};

export default FormTitle;
